import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const UploadIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M12.8348 0.330438C12.3732 -0.110144 11.6268 -0.110144 11.1701 0.330438L4.87946 6.32985C4.41786 6.77043 4.41786 7.48286 4.87946 7.91876C5.34107 8.35465 6.0875 8.35934 6.5442 7.91876L10.8165 3.84103L10.8214 15.3758C10.8214 15.9992 11.3469 16.5007 12 16.5007C12.6531 16.5007 13.1786 15.9992 13.1786 15.3758L13.1786 3.84103L17.4509 7.91876C17.9125 8.35934 18.6589 8.35934 19.1156 7.91876C19.5723 7.47818 19.5772 6.76575 19.1156 6.32985L12.8348 0.330438ZM3.35714 16.1258C3.35714 15.5024 2.8317 15.0009 2.17857 15.0009C1.52545 15.0009 1 15.5024 1 16.1258L1 19.8754C1 22.1533 2.93482 24 5.32143 24L18.6786 24C21.0652 24 23 22.1533 23 19.8754L23 16.1258C23 15.5024 22.4746 15.0009 21.8214 15.0009C21.1683 15.0009 20.6429 15.5024 20.6429 16.1258L20.6429 19.8754C20.6429 20.9112 19.7638 21.7502 18.6786 21.7502L5.32143 21.7502C4.23616 21.7502 3.35714 20.9112 3.35714 19.8754L3.35714 16.1258Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default UploadIcon
